(function($){

    var $controller  = {

        initialized: false,

        selector: '.match-height--row',

        init: function() {
            this.listen();
        },

        isMobile: function() {
            return $(window).width() <= 600;
        },
        
        listen: function() {
            
            setTimeout(function() {
                if(!$controller.isMobile()) {
                    $controller.size();
                }
            }, 200);

            $(window).on('resize', function() {
                $controller.resize();
            });

            $(document).ajaxSuccess(function(){
                $controller.resize();
            });

        },

        size: function() {
            // if(!this.initialized) {
                $($controller.selector).each(function() {
                    var $this = $(this);
                    $this.matchHeight({
                        target: $this.parent(),
                    });
                });
                this.initialized = true;
            // }
        },

        resize: function() {

            if(this.isMobile()) {
                this.detach();
            } else {
                this.size();
            }

        },

        detach: function() {
            $($controller.selector).matchHeight({remove: true});
            this.initialized = false;
        }

    };

    $controller.init();

})(jQuery);


// WEBPACK FOOTER //
// ./tbo/js/listen/match-height.js